<template>
    <div>
        <sweet-modal blocking ref="editVendorInvoice" class="modal" v-on:close="closePurchaseProjectTaskRequest">
            <el-form :model="form" size="mini" label-width="115px" ref="form" status-icon :rules="rules"  class="demo-ruleForm">
                <div style="display:flex; justify-content: center;">
                    <h2 @click="test">Edit Vendor Invoice</h2>
                </div>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="projectId" :label="labelName">
                            <el-select :disabled="disabledInputs" style="width:100%" no-data-text="no date" v-model="form.projectId" placeholder="Project">
                                <el-option
                                        v-for="item in projectList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="form.taskId" :span="12">
                        <el-form-item prop="taskId" label="Task">
                            <el-select clearable :disabled="disabledInputs" style="width:100%" no-data-text="no date" v-model="form.taskId" placeholder="Task">
                                <el-option
                                        v-for="item in taskList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="vendorId" label="Vendor">
                            <el-select :disabled="disabledInputs" style="width:100%" no-data-text="no date" v-model="form.vendorId" placeholder="Vendor">
                                <el-option
                                        v-for="item in vendorList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="handleSelectVendor(item)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="date" label="Date">
                            <el-date-picker
                                    v-model="form.date"
                                    format="d MMM yy"
                                    value-format="timestamp"
                                    type="date"
                                    placeholder="Pick a day">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Current Credit">
                            {{formatPrice(form.vendorCredit)}}
                        </el-form-item>
                        <el-form-item label="Tax Group">
                            {{form.taxGroup}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Due Date" prop="dueDate">
                            <el-date-picker
                                    v-model="form.dueDate"
                                    format="d MMM yy"
                                    value-format="timestamp"
                                    type="date"
                                    placeholder="Pick a day">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="Terms">
                            {{form.terms}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Reference" prop="reference">
                            <el-input placeholder="Reference" v-model="form.reference"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Dimension" prop="dimensionId">
                            <el-select style="width:100%" v-model="form.dimensionId" placeholder="Dimension">
                                <el-option
                                        v-for="item in form.dimesionList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24">
                    <el-form-item label="Description" prop="description">
                        <el-input type="textarea" v-model="form.description"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="Vendors Ref." prop="vendorRefs">
                        <el-input v-model="form.vendorRefs"></el-input>
                    </el-form-item>
                </el-row>
                <!--<el-row :span="24">-->
                    <!--<el-form-item  label="Select Items" prop="itemsId">-->
                        <!--<el-select style="width:100%" v-model="form.itemsId" multiple filterable @remove-tag="removeTag" placeholder="Items">-->
                            <!--<el-option-group-->
                                    <!--class="select-group"-->
                                    <!--@click.native="selectOrder(order)"-->
                                    <!--v-for="order in orderList"-->
                                    <!--:key="order.id"-->
                                    <!--:label="order.code">-->
                                <!--<el-option-->
                                        <!--v-for="item in order.items"-->
                                        <!--:key="item.id"-->
                                        <!--:label="item.name"-->
                                        <!--:value="item.id"-->
                                        <!--@click.native="selectItem(item)">-->
                                <!--</el-option>-->
                            <!--</el-option-group>-->
                        <!--</el-select>-->
                    <!--</el-form-item>-->
                <!--</el-row>-->

                <!--TABLE START -->
                <el-table
                        size="mini"
                        border
                        :data="form.items"
                        style="width: 100%"
                        @cell-click="cellClick">
                    <el-table-column
                            label="P.O."
                            width="100">
                        <template slot-scope="scope">
                            {{scope.row.code}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Name"
                            width="100">
                        <template slot-scope="scope">
                            {{scope.row.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Received On">
                        <template slot-scope="scope">
                            {{moment(scope.row.date.toString(), 'X').format('lll')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Qty Received"
                            width="130">
                        <template slot-scope="scope">
                            {{scope.row.qtyReceived}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Qty Invoiced"
                            width="130">
                        <template slot-scope="scope">
                            {{scope.row.qtyInvoiced}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Qty Yet To Invoice">
                        <template slot-scope="scope">
                            <el-form-item size="mini"
                                          label-width="0"
                                          :prop="'items.' + scope.$index + '.yetToInvoice'"
                                          :rules="{
                                              required: true, message: 'Field is required', trigger: 'blur'
                                              }">
                                <el-input-number size="mini" v-model="scope.row.yetToInvoice" controls-position="right" :min="0" :max="scope.row.qtyReceived - scope.row.qtyInvoiced"></el-input-number>
                            </el-form-item>
                        </template>
                        <!--</template>-->
                    </el-table-column>
                    <el-table-column
                            label="Price before Tax">
                        <template slot-scope="scope">
                            <el-form-item label-width="0"
                                          :prop="'items.' + scope.$index + '.amount'"
                                          :rules="{
                                          required: true, message: 'Field is required', trigger: 'blur'
                                          }">
                                <el-input type="number" v-model="scope.row.amount" size="mini"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Total"
                            width="100">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.countTotals = countTotal(Number(scope.row.yetToInvoice || 0), Number(scope.row.amount || 0)))}}
                        </template>
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--label="Operations"-->
                            <!--width="200">-->
                        <!--<template slot-scope="scope">-->
                            <!--<div>-->
                                <!--<el-button-->
                                        <!--size="mini"-->
                                        <!--type="primary"-->
                                        <!--plain-->
                                        <!--@click="removeItem(scope.$index, scope.row)">Remove</el-button>-->
                            <!--</div>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                </el-table>
                <!--TABLE END -->
                <el-row :span="24" style="display:flex; justify-content: flex-end">
                    <el-col :span="12">
                        <div class="bill">
                            <h4><span>Total Amount : </span>{{formatPrice(form.totalAmount = countTotalAmount(form.items))}}</h4>
                            <el-divider></el-divider>
                        </div>
                    </el-col>
                </el-row>

                <el-form-item style="display: flex; justify-content: flex-end; margin-top:20px;">
                    <el-button @click="vendorInvoiceUpdate('form')" class="modal__btn" type="primary" plain size="medium">Edit</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
    </div>
</template>

<script>
  import axios from 'axios'
  let moment = require('moment')
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';


  export default {
    name: "vendorInvoiceModal",
    components:{
      SweetModal,

    },
    props: ['selectedRow'],
    data() {
      return{
        activeState: 'project',
        vendorInvoiceId: '',
        action: 'create',
        disabledInputs: true,
        labelName: 'Project',
        projectList: [],
        taskList: [],
        vendorList:[],
        orderList:[],
        moment:moment,
        form:{
          projectId: '',
          taskId: '',
          vendorId: '',
          date: null,
          dueDate: null,
          taxGroup: 'Tax',
          vendorCredit: 0,
          terms: 'Payment due within 10 days',
          dimensionId: '',
          reference: null,
          dimesionList: [],
          description: null,
          items:[],
          itemsId:[],
          vendorRefs: '',

          //bill
          totalAmount: 0
        },
        rules:{
          projectId: [
            { required: true, message: 'Please input Project name', trigger: 'blur' }
          ],
          vendorId: [
            { required: true, message: 'Please input Vendor name', trigger: 'blur' }
          ],
          reference: [
            { required: true, message: 'Please pick a reference', trigger: 'blur' }
          ],
          itemsId:[
            { required: true, message: 'Please pick a reference', trigger: 'blur' }
          ]
        },
      }
    },
    watch:{

    },
    computed:{

    },
    methods:{
      test(){
        console.log(this.form.items)
      },
      // // open modal purchases
      async openModalEdit(companyId, projectId, taskId,  vendorInvoiceId, type, user){
        console.log('companyId', companyId, 'projectId', projectId, 'taskId', taskId,  'vendorInvoiceId', vendorInvoiceId, 'type', type, 'user', user)
        try {
          const urlParts = await this.buildUrl(type)

          this.labelName = urlParts.labelName

          this.form = await this.getVendorInvoiceItem(type, vendorInvoiceId)

          await this.$refs.editVendorInvoice.open()
        }catch (err){
          console.log(err)
        }
      },
      getVendorInvoiceItem(type, vendorInvoiceId){
        this.vendorInvoiceId = vendorInvoiceId
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/vendorInvoice/item?type=${type}&id=${vendorInvoiceId}`)
            .then(response => {
                this.form.projectId = response.data.item.projectId,
                this.projectList = [response.data.item.project] || [response.data.item.engagement] || [response.data.item.businessUnit];

                if(response.data.item.projectTask || response.data.item.engagementTask || response.data.item.businessUnitTask){
                  this.form.taskId = response.data.item.projectTaskId || response.data.item.engagementTaskId || response.data.item.businessUnitTaskId;
                  this.taskList = [response.data.item.projectTask] || [response.data.item.engagementTask] || [response.data.item.businessUnitTask]
                }

                this.form.vendorId = response.data.item.vendorInvoice.vendorId;
                this.vendorList = [response.data.item.vendorInvoice.vendor];

                // this.form.vendor = response.data.item.vendorInvoice.vendor,
                this.form.date = response.data.item.vendorInvoice.date !== null ? response.data.item.vendorInvoice.date * 1000: '';
                this.form.dueDate = response.data.item.vendorInvoice.dueDate !== null ? response.data.item.vendorInvoice.dueDate * 1000: '',
                this.form.taxGroup = response.data.item.vendorInvoice.taxGroup,
                this.form.reference = response.data.item.vendorInvoice.reference,
                this.form.vendorRefs = response.data.item.vendorInvoice.vendorRefs,
                this.form.vendorCredit = response.data.item.vendorInvoice.vendorCredit,
                this.form.description = response.data.item.vendorInvoice.description,
                this.form.terms = response.data.item.vendorInvoice.terms;

                this.form.itemsId = response.data.item.vendorInvoice.items.map(item => item.id);
                this.orderList = response.data.item.vendorInvoice.items;
                // console.log('////', response.data.item.vendorInvoice.vendor.purchaseOrder);
                //bill
                this.form.totalAmount = response.data.item.vendorInvoice.totalAmount;

              switch(type){
                case 'project':
                  this.form.project = response.data.item.project
                  this.form.task = response.data.item.projectTask
                  break;
                case 'engagement':
                  this.form.project = response.data.item.engagament
                  this.form.task = response.data.item.engagamentTask
                  break;
                case 'businessUnit':
                  this.form.project = response.data.item.businessUnit
                  this.form.task = response.data.item.businessUnitTask
                  break;
              }

              // create item list
              const items = [];
              response.data.item.vendorInvoice.items.forEach(val => {
                val.code = val.purchaseOrderCode;
                val.yetToInvoice = 0;
                items.push(val)
              });

              this.form.items = items

              resolve(this.form)
            }).catch(error =>{
            console.log(error)
            reject(error)
          })
        })
      },
      resetForm(isProj) {
        if(this.form.items.length !== 0){
          this.form.items = []
          this.orderList = []
          this.form.itemsId = []
          this.form.vendorId = ''
        }else if(!this.form.items.length) {
          this.form.vendorId = ''
        }
        if(isProj){
          this.form.taskId = ''
        }
      },
      selectItem(item){
        console.log('itm', item)
        for (let i = 0; i < this.form.items.length; i++){
          if(this.form.items[i].id === item.id || item.id === this.form.items[i].purchaseOrderItemId){
            this.form.items.splice(i, 1)
            return
          }
        }


        let orderCode = ''
        for (let b = 0; b < this.orderList.length; b++){
          if(item.purchaseOrderId === this.orderList[b].id){
            orderCode =  this.orderList[b].code
          }
        }

        const itm = {
          id: item.id,
          purchaseOrderId: item.purchaseOrderId,
          name: item.name,
          closed: item.closed,
          backorder: item.backorder,
          received: item.received,
          amount: item.amount,
          qty: item.qty,
          vatExclusive: item.vatExclusive,
          taxId: item.taxId,
          itemWhTaxId: item.itemWhTaxId,
          unitId: item.unitId,
          total: item.total,
          date: item.date,
          code: orderCode,
          originalItemId: item.originalItemId,

          yetToInvoice: null,
          qtyReceived: null,
          qtyInvoiced: null,
          countTotals: null
        }

        console.log('item 2', item)
        this.form.items.push(itm)
      },
      // countQtyReceived(qty, backorder){
      //   console.log('qty, backorder', qty, backorder)
      //   return backorder === 0 ? 0 : qty - backorder
      // },
      // countQtyInvoiced(qtyReceived, yetToInvoice){
      //   console.log('qtyReceived, yetToInvoice', qtyReceived, yetToInvoice)
      //   return yetToInvoice === 0 ? 0 : qtyReceived - yetToInvoice
      // },
      countTotal(yetToInvoice, amount){
        console.log('yetToInvoice, amount', yetToInvoice, amount)
        if(yetToInvoice === 0 || amount === 0){
          return 0
        }else{
          return yetToInvoice * amount
        }
      },
      countBackOrder(scope){
        console.log('scope', scope)
      },
      addItem(index, row){
        console.log(index, row)
      },
      removeItem(index, row){
        this.removeTag(row.id)
        for (let i = 0; i < this.form.itemsId.length; i++){
          if(this.form.itemsId[i] === row.id || this.form.itemsId[i] === row.purchaseOrderItemId){
            this.form.itemsId.splice(i, 1)
          }
        }
      },
      removeTag(id){
        for (let i = 0; i < this.form.items.length; i++){
          if(this.form.items[i].id === id || id === this.form.items[i].purchaseOrderItemId){
            this.form.items.splice(i, 1)
            return
          }
        }
      },
      countTotalAmount(items){
        console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!', items)
        const results = []
        for (let i = 0; i < items.length; i++) {
          results.push(items[i].countTotals)
        }

        if (results.length === 0) {
          return 0
        }else {
          const result = results.reduce(function (sum, current) {
            return sum + current
          });
          console.log('res', result)
          return result
        }
      },
      selectOrder(order){
        console.log('order', order)
      },
      vendorInvoiceUpdate(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            const urlParts = this.buildUrl(this.activeState)
            if(this.form.items.length === 0) {
              return this.$message({
                type: 'error',
                message: 'Select items'
              })
            }

            const data = {
              projectId: this.form.projectId,
              taskId: this.form.taskId || null,
              vendorId: this.form.vendorId,
              date: this.form.date / 1000 || null,
              vendorCredit: this.form.vendorCredit || null,
              dueDate: this.form.date / 1000 || null,
              taxGroup: this.form.taxGroup || null,
              terms: this.form.terms || null,
              reference: this.form.reference || null,
              dimensionId: this.form.dimensionId || null,
              description: this.form.description || null,
              vendorRefs: this.form.vendorRefs || null,


              //bill
              totalAmount: this.form.totalAmount,
            }

            const items = []
            this.form.items.forEach(val => {
              const item = {
                id: val.id,
                receivedPurchaseOrderItemId: val.receivedPurchaseOrderItemId,
                purchaseOrderItemId: val.purchaseOrderItemId || val.id,
                purchaseOrderId: val.purchaseOrderId,
                name: val.name,
                closed: val.closed,
                backorder: val.backorder,
                received: val.received,
                amount: val.amount,
                qty: val.qty,
                vatExclusive: val.vatExclusive,
                taxId: val.taxId,
                itemWhTaxId: val.itemWhTaxId,
                unitId: val.unitId,
                total: val.total,
                date: val.date,
                purchaseOrderCode: val.code,
                originalItemId: val.originalItemId,

                yetToInvoice: val.yetToInvoice,
                qtyReceived: val.qtyReceived,
                qtyInvoiced: val.qtyInvoiced + val.yetToInvoice,
                countTotals: val.countTotals

              };
              items.push(item)
            });
            data.items = items
            return new Promise((resolve, reject) =>{
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/vendorInvoice/update?id=${this.vendorInvoiceId}`, data)
                .then(response => {
                  this.notification("Success", "Vendor Invoice Updated", "success")
                  this.$emit('setValueProject', this.form.projectId);
                  this.$refs.editVendorInvoice.close()
                })
                .catch(error => {
                  console.log(error.response.data);
                  console.log('An error occurred:', error);
                  reject(error)
                });
            })
          }
        })
      },
      closePurchaseProjectTaskRequest(){
        this.$refs['form'].resetFields();
        this.form.items = []
        this.disabledInputs = true
        this.projectList = []
        this.taskList = []
        this.vendorList =[]
        this.orderList = []
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      cellClick(row, column, event){
        console.log('row', row)
        console.log('column', column)
      },
      buildUrl(state) {
        let routeName = ''
        let labelName = ''
        let stateProjectId = ''
        let projectId = ''
        let stateTaskId = ''
        let taskId = ''
        let stateExpenseId = ''
        let stateProjectTasks = ''
        let stateTask = ''
        switch (state){
          case 'project':
            routeName = 'projects'
            labelName = 'Project'
            stateProjectId = 'projectId'
            stateProjectTasks = 'projectTasks'
            stateTaskId = 'projectTaskId'
            stateExpenseId = 'projectTaskVendorInvoiceId'
            stateTask = 'projectTask'
            break;
          case 'engagement':
            routeName = 'engagements'
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTasks = 'engagementTasks'
            stateExpenseId = 'engagementTaskVendorInvoiceId'
            labelName = 'Engagement'
            stateTask = 'engagementTask'
            break;
          case 'businessUnit':
            routeName = 'businessUnits'
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTasks = 'businessUnitTasks'
            stateExpenseId = 'businessUnitTaskVendorInvoiceId'
            labelName = 'Business Unit'
            stateTask = 'businessUnitTask'
            break;
        }
        return {
          state: state,
          routeName: routeName,
          stateProjectId: stateProjectId,
          labelName: labelName,
          projectId: projectId,
          stateTaskId: stateTaskId,
          stateProjectTasks: stateProjectTasks,
          taskId: taskId,
          stateExpenseId: stateExpenseId,
          stateTask: stateTask }
      }
    }
  }
</script>

<style lang="less" scoped>
    /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
        width:100%;
    }
    /deep/.sweet-modal-overlay{
        z-index:1000;
        .sweet-modal {
            max-width: 100% !important;
        }
    }
    .bill{
        text-align:right;
        h4{
            line-height:0.6;
            span{
                padding: 0 10px;
            }
        }
        .payment-to-vendor{
            background: rgb(227, 228, 230);
            h3{
                span{
                    padding: 0 10px;
                }
            }
        }
    }
</style>
